import { Box, Typography, useTheme } from "@mui/material"
import { Trans } from "react-i18next"
import { useTranslation } from "providers/i18n"
import { useVenue } from "providers/venue"
import { useDirectionOverview } from "hooks/direction/useDirectionOverview"

export const DirectionSummary = ({
  duration,
  distance,
  originName,
  destinationName,
}) => {
  const { t } = useTranslation()

  const theme = useTheme()

  const { isMultiOrdinalVenue } = useVenue()

  const { originLevelName, destinationLevelName } = useDirectionOverview()

  const {
    primaryText,
    secondaryText,
    highlightedText,
    directionSummaryContainer,
  } = theme.components[`AppDirectionOverview`]?.styleOverrides || {}

  const highlightedStepText = (
    <Typography
      className="AppDirectionOverview-highlightedText"
      component="span"
      sx={highlightedText}
    />
  )

  const originFloorText = isMultiOrdinalVenue
    ? `(${t("At Floor", {
        value: originLevelName,
      })})`
    : ""
  const destinationFloorText = isMultiOrdinalVenue
    ? `(${t("At Floor", {
        value: destinationLevelName,
      })})`
    : ""

  return (
    <Box sx={directionSummaryContainer}>
      <Typography variant="title" component="h1" sx={primaryText} gutterBottom>
        <Trans
          components={{
            duration: highlightedStepText,
            distance: highlightedStepText,
          }}
        >
          {t("Travel", {
            duration,
            distance,
          })}
        </Trans>
      </Typography>
      <Typography color="text.secondary" variant="body2" sx={secondaryText}>
        <Trans
          components={{
            origin: highlightedStepText,
            destination: highlightedStepText,
          }}
        >
          {t("Origin To Destination", {
            origin: `${t(originName)} ${originFloorText}`,
            destination: `${t(destinationName)} ${destinationFloorText}`,
          })}
        </Trans>
      </Typography>
    </Box>
  )
}
